import React from 'react';
import { OC, FONT } from '../constants/index.js';
import { useTheme } from '../constants/index.js';
import { Button } from './ui.js';

export function LoadingState({ message = 'Loading…', theme = 'light' }) {
  const t = useTheme(theme);
  return React.createElement('div', {
    style: {
      padding: '48px 24px',
      textAlign: 'center',
      color: t.text.secondary,
      fontFamily: FONT.body,
      fontSize: 15,
    },
  }, message);
}

export function ErrorState({ message = 'Something went wrong.', onRetry, theme = 'light' }) {
  const t = useTheme(theme);
  return React.createElement('div', {
    style: {
      padding: '40px 24px',
      textAlign: 'center',
      border: `1px solid ${t.border.base}`,
      borderRadius: 14,
      background: t.bg.card,
    },
  },
    React.createElement('div', { style: { color: OC.urgent, fontWeight: 700, marginBottom: 8 } }, 'Could not load data'),
    React.createElement('div', { style: { color: t.text.secondary, marginBottom: 16, fontSize: 14 } }, message),
    onRetry ? React.createElement(Button, { kind: 'secondary', size: 'md', theme, onClick: onRetry }, 'Try again') : null
  );
}

export function EmptyState({ title = 'Nothing here yet', message, actionLabel, onAction, theme = 'light' }) {
  const t = useTheme(theme);
  return React.createElement('div', {
    style: {
      padding: '40px 24px',
      textAlign: 'center',
      border: `1px dashed ${t.border.base}`,
      borderRadius: 14,
      color: t.text.secondary,
    },
  },
    React.createElement('div', { style: { fontWeight: 700, color: t.text.primary, marginBottom: 8, fontSize: 16 } }, title),
    message ? React.createElement('div', { style: { marginBottom: 16, fontSize: 14 } }, message) : null,
    onAction ? React.createElement(Button, { kind: 'primary', size: 'md', theme, onClick: onAction }, actionLabel || 'Continue') : null
  );
}
